var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M6.5 5v.5h5v1h-5v5h-1v-5h-5v-1h5v-5h1V5z","fill":"#000","stroke":"#974900"}})])}
var staticRenderFns = []

export { render, staticRenderFns }